import React from 'react';
import TextareaAutosize from 'react-autosize-textarea';

export class FormTextField extends React.Component {
  constructor() {
    super();
    this.state = { rows: 2 };
    this.blur = this.blur.bind(this);
    this.focus = this.focus.bind(this);
  }

  componentWillMount() {
    this.state = { rows: this.props.rows || 2 };
  }

  blur() {
    this.setState({ rows: 1 });
    if (this.props.onBlur) {
      this.props.onBlur(this.refs[this.props.name].refs.textarea.value);
    }
  }

  focus() {
    this.setState({ rows: this.props.rows || 2 });
  }

  render() {
    return (
      <TextareaAutosize
        className="form-control"
        ref={this.props.name}
        name={this.props.name}
        rows={this.state.rows}
        disabled={this.props.disabled === undefined ? this.context.disabled : this.props.disabled}
        readOnly={this.props.readOnly === undefined ? this.context.readonly : this.props.readOnly}
        onBlur={this.blur}
        onFocus={this.focus}
        value={this.props.defaultValue || ''}
        placeholder={this.props.placeholder}
        style={{ resize: 'none' }}
        onChange={e => (this.props.onChangeFunc ? this.props.onChangeFunc(e.target.value) : {})}
      />
    );
  }
}
FormTextField.propTypes = {
  name: React.PropTypes.string,
  rows: React.PropTypes.number,
  defaultValue: React.PropTypes.string,
  placeholder: React.PropTypes.string,
  onBlur: React.PropTypes.func,
  disabled: React.PropTypes.bool,
  readOnly: React.PropTypes.bool,
  onChangeFunc: React.PropTypes.func,
};

FormTextField.contextTypes = {
  disabled: React.PropTypes.bool,
  readonly: React.PropTypes.bool,
};
